import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { CrewAvatars } from "@/components/crew-avatars";
import { Terminal } from "@/components/ui/terminal";
import { useStoreSynced } from "@/lib/store-synced";

export function MainPage() {
  const { setClientStatusChannel } = useStoreSynced(
    useShallow((s) => ({
      setClientStatusChannel: s.setClientStatusChannel,
    })),
  );

  useEffect(() => {
    setClientStatusChannel("MainPage");
    return () => {
      setClientStatusChannel();
    };
  }, [setClientStatusChannel]);

  return (
    <div className="relative flex h-full w-full">
      <div className="section-left w-64 shrink-0">
        <CrewAvatars />
      </div>
      <div className="section-center flex-1">
        <Terminal className="w-full" />
      </div>
      <div className="section-right w-64 shrink-0"></div>
    </div>
  );
}
